/**
 * DOCUMENTATION
 *
 * This code will take a list of departments with 'id' and 'parent_id' and output
 * a list with the same departments tagged with their 'level', starting at 0
 *
 * It works by first finding the 'roots' of the structure, i.e those with
 * parent_id = null.
 *
 * Starting with these 'roots' we assign these to level 0 then iterate through the children of
 * 'roots', these will be level 1. We find the children of these, which will be level 2........
 * and so on
 */

/**
 * Return list of departments with no 'parent_id'
 * @param {Array} departments array of all departments
 */
const findRoots = (departments) => {
  // find all departments that have no parent
  const roots = departments.filter((d) => d.top === true)
  return roots
}

/**
 * Iterate through all departments and find children of @parent
 * @param {Array} departments List of all departments
 * @param {Object} parent A department
 */
const findChildren = (departments, parent) => {
  const children = departments.filter(
    (department) => department.parent_id === parent.id
  )
  return children
}

/**
 * Iterate through all departments, find and tag departments with their correct level-level
 * Output result in 'levelList'
 * @param {Array} departments all departments
 * @param {Array} parents subset of departments are parents(possibly)
 * @param {Number} level counter for level level
 * @param {Array} levelList resulting collection of tagged departments
 */
const buildTier = (departments, parents, level, levelList) => {
  // Get children of parents
  const children = parents.map((parent) => {
    return findChildren(departments, parent)
  })

  // flatten nested arrays : [[1,2][3,4]] -> [1,2,3,4]
  const flatChildren = children.flat()

  if (flatChildren.length === 0) {
    // end condition, no more children to find
    return levelList
  }
  // make array of children on current level, tag with 'level'
  // and add to 'levelList'
  // increment 'level' counter and call self with list of children
  const taggedChildren = flatChildren.map((child) => {
    return {
      ...child,
      level,
    }
  })

  // depth first
  taggedChildren.forEach((child) => {
    const tier = buildTier(departments, [child], level + 1, [child])
    levelList.push(...tier)
  })

  return levelList
}

export const findHierarchyLevels = (departments) => {
  // Where the result will come out
  const levelList = []
  const startLevel = 1
  const roots = findRoots(departments)

  const taggedRoots = roots.map((root) => {
    return {
      ...root,
      level: startLevel,
    }
  })

  taggedRoots.forEach((root) => {
    const tier = buildTier(departments, [root], startLevel + 1, [root])
    levelList.push(...tier)
  })

  return levelList
}
